/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { FunctionComponent, useEffect, useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'

import { Grid } from '@material-ui/core'
import IFindAllImpl from 'modules/lotes/domain/usecases/FindAllImpl'
import IFindByIdImpl from 'modules/lotes/domain/usecases/FindByIdImpl'
import IVerificaCargaDisponivelImpl from 'modules/lotes/domain/usecases/VerificaCargaDisponivelImpl'
import { useDirecionaCarga } from 'modules/lotes/hooks/direcionaCarga'
import { useFiltros } from 'modules/lotes/hooks/filtros'
import { formatBreadCrumb } from 'shared/components/BasePage/formatBreadCrumb'
import Button from 'shared/components/Button'
import Center from 'shared/components/Center'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import Pagination from '../../../../shared/components/Pagination'
import SnackBar from '../../../../shared/components/SnackBar'
import { colors } from '../../../../shared/styles/colors'
import LoteCard from '../components/LoteCard'
import {
  BreadCrumb,
  ContainerCards,
  ContainerCenter,
  ContainerIcons,
  Content,
  Title,
} from './styles'
import ILoteResponseData from 'modules/lotes/domain/entities/ILoteResponseData'
import Frotista from 'modules/user/domain/entities/Frotista'

import ModalRequisitosViagem from './ModalRequisitosViagem'
import ValidateRequisitosViagemImpl from 'modules/user/domain/usecases/ValidateRequisitosViagemImpl'
import ModalMultiplosCnpjsRequisitosViagem from './ModalMultiplosCnpjsRequisitosViagem'
import { ListFrotista } from 'modules/user/domain/usecases/ListFrotista'
import EStatusConta from 'modules/lotes/domain/entities/EStatusConta'
import ValidateLoteQuarteirizadoImpl from 'modules/lotes/domain/usecases/ValidateLoteQuarteirizado'

type TProps = {
  findAll: IFindAllImpl
  findById: IFindByIdImpl
  verificaCargaDisponivel: IVerificaCargaDisponivelImpl
  validateRequisitosViagem: ValidateRequisitosViagemImpl
  listFrotistas: ListFrotista
  validateLoteQuarteirizado: ValidateLoteQuarteirizadoImpl
}

const Lotes: FunctionComponent<TProps> = ({
  findAll,
  findById,
  verificaCargaDisponivel,
  validateRequisitosViagem,
  listFrotistas,
  validateLoteQuarteirizado,
}) => {
  const {
    id,
    valor,
    destino,
    origem,
    lotes,
    raioOrigem,
    raioDestino,
    produto,
    lotesDirecionados,
    setLotes,
    lastFilter,
  } = useFiltros()
  const history = useHistory()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState('')
  const [countFilters, setCountFilters] = useState(0)
  const { setLote, setCidadeDestino, setCidadeOrigem } = useDirecionaCarga()
  const { setFrotista, setFrotistaId, frotistas, setFrotistas } = useFrotista()
  const [openModalRequisitos, setOpenModalRequisitos] = useState(false)
  const [
    openModalRequisitosMultiplosCnpjs,
    setOpenModalRequisitosMultiplosCnpjs,
  ] = useState(false)
  const [requisitosViagem, setRequisitosViagem] = useState({})

  useEffect(() => {
    setFrotistaId(null)
    setFrotista({} as Frotista)
  }, [])

  const isMesmoFiltro = () => {
    return (
      lastFilter.origem === origem &&
      lastFilter.destino === destino &&
      lastFilter.loteId === id &&
      lastFilter.valor === valor &&
      lastFilter.raioDestino === raioOrigem &&
      lastFilter.raioDestino === raioDestino &&
      lastFilter.produto.id === produto.id &&
      lastFilter.lotesDirecionados === lotesDirecionados
    )
  }

  const isLoteQuarteirizado = async (idLote: number) => {
    const loteQuarteirizado = await validateLoteQuarteirizado.execute(idLote)
    return loteQuarteirizado
  }

  useEffect(() => {
    const init = async () => {
      setLoading(true)

      try {
        let total = 0
        if (id) total += 1
        if (valor) total += 1
        if (destino) total += 1
        if (origem) total += 1
        if (raioOrigem !== 100) total += 1
        if (raioDestino !== 100) total += 1
        if (produto?.id) total += 1
        if (lotesDirecionados) total += 1
        setCountFilters(total)
        if (!isMesmoFiltro()) {
          const response = await findAll.execute({
            page: currentPage || 1,
            id,
            valor,
            destino,
            origem,
            raio_origem: raioOrigem,
            raio_destino: raioDestino,
            produto_id: produto?.id,
            lotes_direcionados: lotesDirecionados,
          })
          const { data } = response
          setLotes(data)
          setTotalRecords(response.total)
        }
        setLoading(false)
      } catch (error) {
        setError(true)
        setLoading(false)
      }
    }

    init()
  }, [currentPage])

  const temCnpjsSemContaPay = async (): Promise<boolean> => {
    if (frotistas.length === 1) {
      return false
    }

    const result = await listFrotistas.execute({
      nome: '',
      page: 1,
      per_page: 999,
      active: true,
    })
    let frotistaPrecisaContaPay = false
    result.data.forEach(frotista => {
      if (
        frotista.status_conta !== EStatusConta.ATIVA &&
        frotista.status_conta !== EStatusConta.CONTA_NAO_NECESSARIA
      ) {
        frotistaPrecisaContaPay = true
      }
    })
    setFrotistas(result.data)
    setLoading(false)
    return frotistaPrecisaContaPay
  }

  const frotistaUnicoSemContaPay = async (): Promise<boolean> => {
    if (frotistas.length > 1) {
      return false
    }

    const result = await validateRequisitosViagem.execute(frotistas[0].id)

    if (
      result.data.caminhao.value !== 'OK' ||
      result.data.tmovPay.value !== 'OK' ||
      result.data.motorista.value !== 'OK' ||
      result.data.veiculo.value !== 'OK'
    ) {
      setLoading(false)
      setRequisitosViagem(result.data)
      return true
    }
  }

  const continuarDirecionamento = async (loteId, origem, destino) => {
    const responseFindById = await findById.execute({ id: loteId })
    setLote(responseFindById)
    setCidadeOrigem(origem)
    setCidadeDestino(destino)
    history.push('/direciona-carga')
  }

  const parceiroSemContaPay = () => {
    const findParceiro = frotistas.find(x => x.is_matriz && x.quarteirizacao)
    return findParceiro?.status_conta !== EStatusConta.ATIVA
  }

  const handleDirecionarCarga = async (loteId, origem, destino) => {
    setLoading(true)
    try {
      const response = await verificaCargaDisponivel.execute(loteId)
      setLoading(false)
      const isFrotistaUnicoSemContaPay = await frotistaUnicoSemContaPay()
      const isLoteQuarteirizacao = await isLoteQuarteirizado(loteId)
      const temCnpjsSemConta = await temCnpjsSemContaPay()
      const isParceiroSemContaPay = parceiroSemContaPay()

      if (response.isValid) {
        if (isLoteQuarteirizacao) {
          if (isParceiroSemContaPay) {
            history.push({
              pathname: '/tmov-pay-instructions',
              state: { quarteirizacao: true },
            })
          } else {
            continuarDirecionamento(loteId, origem, destino)
          }
          return
        }

        if (temCnpjsSemConta) {
          setOpenModalRequisitosMultiplosCnpjs(true)
          return
        }
        if (isFrotistaUnicoSemContaPay) {
          setOpenModalRequisitos(true)
          return
        }

        continuarDirecionamento(loteId, origem, destino)
      } else {
        setOpen(true)
        setMessages(response.messages?.join(' '))
      }
    } catch (error) {
      setOpen(true)
      setMessages(
        'Não foi possível direcionar a carga, tente novamente mais tarde.',
      )
      setLoading(false)
    }
  }

  const handleDetalhes = async (
    lote: ILoteResponseData,
    lotes: ILoteResponseData[],
    index: number,
  ) => {
    setLoading(true)
    try {
      const response = await verificaCargaDisponivel.execute(lote.id)
      setLoading(false)
      const responseFindById = await findById.execute({ id: lote.id })
      setLote(responseFindById)
      setCidadeOrigem(origem)
      setCidadeDestino(destino)

      if (response.isValid) {
        history.push('/detalhes-carga', {
          lote,
          lotes,
          index,
        })
      } else {
        setMessages(response.messages?.join(' '))
        setOpen(true)
      }
    } catch (error) {
      setMessages(
        'Não foi possível carregar os detalhes da oferta, por favor tente novamente em alguns minutos.',
      )
      setLoading(false)
      setOpen(true)
    }
  }

  return (
    <>
      <Content>
        <BreadCrumb>
          <Title>{formatBreadCrumb('Oferta de cargas')}</Title>
          <ContainerIcons>
            <FaFilter color={colors.green} />
            <Button
              aria-label="btn-lote-filter-page"
              size={'small'}
              fontColor={colors.blue}
              color={'transparent'}
              onClick={() => history.push('/lotes/filtros')}
            >
              {countFilters ? `FILTRAR(${countFilters})` : 'FILTRAR'}
            </Button>
          </ContainerIcons>
        </BreadCrumb>
        {loading ? (
          <LoadingBackdrop open={loading} color={colors.green} />
        ) : error ? (
          <ContainerCenter>
            Não foi possível carregar as ofertas, por favor tente novamente em
            alguns minutos.
          </ContainerCenter>
        ) : (
          <ContainerCards>
            {lotes?.length > 0 ? (
              <Grid container spacing={2}>
                {lotes.map((value, idx) => (
                  <Grid key={value.id} item xs={12} sm={6} md={4} lg={4} xl={3}>
                    <LoteCard
                      lote={value}
                      lotes={lotes}
                      index={idx}
                      setLoading={setLoading}
                      setMessages={setMessages}
                      setOpen={setOpen}
                      onClickEnviarCarga={handleDirecionarCarga}
                      onClickVisualizar={() =>
                        handleDetalhes(value, lotes, idx)
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Center>
                {lotes} {lotes?.length} Não há resultados para essa busca.
              </Center>
            )}
          </ContainerCards>
        )}
        <Pagination
          recordsPerPage={15}
          totalRecords={totalRecords}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </Content>
      <SnackBar
        open={open}
        message={messages}
        setOpen={setOpen}
        severity={'error'}
      />
      <ModalRequisitosViagem
        openModalRequisitos={openModalRequisitos}
        setOpenModalRequisitos={setOpenModalRequisitos}
        requisitosViagem={requisitosViagem}
      />
      <ModalMultiplosCnpjsRequisitosViagem
        openModalRequisitos={openModalRequisitosMultiplosCnpjs}
        setOpenModalRequisitos={setOpenModalRequisitosMultiplosCnpjs}
        frotistas={frotistas}
        direcionamentoCarga={continuarDirecionamento}
      />
    </>
  )
}

export default Lotes
